import { KnowledgeBaseFacade } from '@agent/core/store/knowledge-base/knowledge-base.facade';
import { Component, Input, OnInit } from '@angular/core';

import { ResponseModel } from '../../models/responseModel';

@Component({
  selector: 'knowledge-base-suggestions',
  templateUrl: 'knowledge-base-suggestions.component.html',
  styleUrls: ['./knowledge-base-suggestions.component.scss'],
})
export class KnowledgeBaseSuggestionsComponent implements OnInit {
  @Input() readonly mediaExternalId: string;
  suggestedResults: ResponseModel[] = [];
  expandAll: boolean = false;

  constructor(private readonly knowledgeBaseFacade: KnowledgeBaseFacade) {}

  ngOnInit() {
    this.knowledgeBaseFacade.suggestedResults$.subscribe((suggestedResults: ResponseModel[]) => {
      this.suggestedResults = suggestedResults;
    });
  }

  toggleExpandAll(): void {
    this.expandAll = !this.expandAll;
  }
}
